module.exports = __webpack_public_path__ + "static/media/gear-red.dadcb2f4.svg";